import { ErrorHandler as ExceptionHandler } from '@angular/core';
import { ErrorHandler } from './error-handler';

export const customExceptionHandlerFactory = (
    errorHandler: ErrorHandler
): ExceptionHandler => {
    class CustomExceptionHandler implements ExceptionHandler {
        handleError(exception: any): void {
            // Pass exception to error handler.
            const error =
                exception.rejection || exception.originalException || exception;
            errorHandler.error(error);
        }
    }

    return new CustomExceptionHandler();
};

export const customExceptionHandlerProvider = {
    provide: ExceptionHandler,
    useFactory: customExceptionHandlerFactory,
    deps: [ErrorHandler],
};
